// extracted by mini-css-extract-plugin
export default {"imageWrapper":"GI-z","twoColumnImage":"HI-z"};